module.exports = __webpack_public_path__ + "185fde51b6f91b899583fc8c7c69b4d0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CR.svg
// module id = /e1p
// module chunks = 0